<template>
  <section class="product-details-page">
   <NavBar />
    <div v-if="product" class="details-container">

      <!-- Product Image -->
      <div class="details-image">
        <img :src="product.image" :alt="product.name">
      </div>

      <!-- Product Information -->
      <div class="details-info">

        <p class="product-category">
          {{ product.category }}
        </p>

        <h1>{{ product.name }}</h1>

        <h2>&#8358;{{ product.price.toLocaleString() }}</h2>

        <div class="product-line"></div>

        <p class="description">
          {{ product.description }}
        </p>

        <div class="product-information">

          <p>
            <strong>Color:</strong> {{ product.color }}
          </p>

          <p>
            <strong>Material:</strong> Genuine Leather
          </p>

          <p>
            <strong>Availability:</strong> In Stock
          </p>

        </div>

        <div class="product-features">

          <h3>Product Features</h3>

          <ul>
            <li>High-quality leather construction</li>
            <li>Durable and comfortable design</li>
            <li>Stylish and versatile design</li>
            <li>Designed for long-lasting use</li>
          </ul>

        </div>

        <div class="details-buttons">

          <button @click="addToCart">
            Add to Cart
          </button>

          <button class="back-button" @click="goBack">
            Back to {{ product.category }}
          </button>

        </div>

      </div>

    </div>

    <div v-else class="product-not-found">

      <h2>Product Not Found</h2>

      <p>
        Sorry, this product does not exist.
      </p>

      <button @click="goBack">
        Back
      </button>

    </div>

    <div>
        <FooterPage />
    </div>

  </section>
</template>

<script>
import NavBar from '../components/NavBar.vue'
import FooterPage from '../components/FooterPage.vue'


export default {
    components: {
        NavBar, FooterPage
    },

  data() {
  return {

    products: [

      // =========================
      // BAGS — ID 1-8
      // =========================

      {
        id: 1,
        category: 'LEATHER BAG',
        name: 'Crossbody',
        price: 22000,
        color: 'Brown',
        image: require('../assets/thecrossbody.avif'),
        description:
          'A stylish and durable leather crossbody bag designed for convenient everyday use.'
      },

      {
        id: 2,
        category: 'LEATHER BAG',
        name: 'The Grace',
        price: 20000,
        color: 'Nude',
        image: require('../assets/thegrace.avif'),
        description:
          'A beautiful and elegant leather bag with a refined design, perfect for different occasions.'
      },

      {
        id: 3,
        category: 'LEATHER BAG',
        name: 'Classic Bag',
        price: 30000,
        color: 'Brown',
        image: require('../assets/theclassic.avif'),
        description:
          'A timeless and stylish leather bag designed for everyday use and effortless elegance.'
      },

      {
        id: 4,
        category: 'LEATHER BAG',
        name: 'Tote Bag',
        price: 11000,
        color: 'Light Brown',
        image: require('../assets/thetote.avif'),
        description:
          'A spacious and versatile leather tote, perfect for everyday use and carrying your essentials.'
      },

      {
        id: 5,
        category: 'LEATHER BAG',
        name: 'Drawstring',
        price: 18000,
        color: 'Black',
        image: require('../assets/thedrawstring.avif'),
        description:
          'A stylish drawstring leather bag with a practical design, perfect for casual outings and everyday use.'
      },

      {
        id: 6,
        category: 'LEATHER BAG',
        name: 'Charm Bag',
        price: 16000,
        color: 'Nude',
        image: require('../assets/thecharm.avif'),
        description:
          'A charming and elegant leather bag with a stylish design that adds a sophisticated touch to any outfit.'
      },

      {
        id: 7,
        category: 'LEATHER BAG',
        name: 'Croc Bag',
        price: 25000,
        color: 'Wine',
        image: require('../assets/thecroc.avif'),
        description:
          'A bold croc-textured leather bag that combines a distinctive look with a practical everyday style.'
      },

      {
        id: 8,
        category: 'LEATHER BAG',
        name: 'Office Bag',
        price: 11000,
        color: 'Brown',
        image: require('../assets/officebag.jpg'),
        description:
          'A sleek and practical leather office bag designed for effortless everyday carrying.'
      },

      // =========================
      // BELTS — ID 9-16
      // =========================

      {
        id: 9,
        category: 'LEATHER BELT',
        name: 'Sterling Belt',
        price: 6500,
        color: 'Brown',
        image: require('../assets/sterlingbelts.avif'),
        description:
          'A stylish and durable leather belt designed to add a classic touch to both casual and formal outfits.'
      },

      {
        id: 10,
        category: 'LEATHER BELT',
        name: 'Heritage Belt',
        price: 5500,
        color: 'Black',
        image: require('../assets/heritagebelt.avif'),
        description:
          'A classic leather belt that combines timeless style with durable craftsmanship.'
      },

      {
        id: 11,
        category: 'LEATHER BELT',
        name: 'Aura Belt',
        price: 7500,
        color: 'Green',
        image: require('../assets/aurabelt.avif'),
        description:
          'A simple and elegant leather belt designed to complement a variety of outfits.'
      },

      {
        id: 12,
        category: 'LEATHER BELT',
        name: 'Rugged Belt',
        price: 10000,
        color: 'Brown',
        image: require('../assets/ruggedbelt.avif'),
        description:
          'A strong and stylish leather belt designed for customers looking for a durable everyday accessory.'
      },

      {
        id: 13,
        category: 'LEATHER BELT',
        name: 'Belle Belt',
        price: 6000,
        color: 'Brown',
        image: require('../assets/bellebelt.jpg'),
        description:
          'A classic leather belt that adds a polished and stylish finish to your outfit.'
      },

      {
        id: 14,
        category: 'LEATHER BELT',
        name: 'Contrast Belt',
        price: 9500,
        color: 'Brown',
        image: require('../assets/contrastbelt.jpg'),
        description:
          'A distinctive leather belt combining stylish design with durable construction.'
      },

      {
        id: 15,
        category: 'LEATHER BELT',
        name: 'Blush Belt',
        price: 7000,
        color: 'Pink',
        image: require('../assets/Blushbelt.jpg'),
        description:
          'A soft and stylish leather belt designed to add a fashionable touch to your outfit.'
      },

      {
        id: 16,
        category: 'LEATHER BELT',
        name: 'Classic Belt',
        price: 7800,
        color: 'Burgundy',
        image: require('../assets/classicbelt.jpg'),
        description:
          'A timeless leather belt that offers a classic look with exceptional durability designed to work effortlessly with both casual and formal outfits.'
        },

        // =========================
      // SHOES — ID 17-24
      // =========================

      {
        id: 17,
        category: 'LEATHER SHOE',
        name: 'Monarch Shoe',
        price: 21000,
        color: 'Brown',
        image: require('../assets/themonarch.avif'),
        description:
          'A stylish and durable leather shoe designed to provide a polished look for different occasions.'
      },

      {
        id: 18,
        category: 'LEATHER SHOE',
        name: 'Lace Shoe',
        price: 25000,
        color: 'White',
        image: require('../assets/thelace.avif'),
        description:
          'A stylish leather lace-up shoe combining a clean design with comfortable everyday wear.'
      },

      {
        id: 19,
        category: 'LEATHER SHOE',
        name: 'Ranger Shoe',
        price: 30000,
        color: 'Brown',
        image: require('../assets/theranger.avif'),
        description:
          'A durable leather shoe with a strong and classic design suitable for everyday wear.'
      },

      {
        id: 20,
        category: 'LEATHER SHOE',
        name: 'Stride Shoe',
        price: 34000,
        color: 'Dark brown',
        image: require('../assets/thestride.avif'),
        description:
          'A sleek leather shoe designed to provide a stylish and comfortable finish for different outfits.'
      },

      {
        id: 21,
        category: 'LEATHER SHOE',
        name: 'Maverick Shoe',
        price: 29000,
        color: 'Brown',
        image: require('../assets/themaverick.avif'),
        description:
          'A modern leather shoe with a stylish design suitable for both casual and smart occasions.'
      },

      {
        id: 22,
        category: 'LEATHER SHOE',
        name: 'Poise Shoe',
        price: 28000,
        color: 'Lavender',
        image: require('../assets/thepoise.avif'),
        description:
          'A stylish leather shoe designed to bring a refined and confident touch to your outfit.'
      },

      {
        id: 23,
        category: 'LEATHER SHOE',
        name: 'Madam Shoe',
        price: 30000,
        color: 'Light Brown',
        image: require('../assets/themadam.jpg'),
        description:
          'A sophisticated leather shoe designed to provide a polished and elegant look for different occasions.'
        },

        {
            id: 24,
            category: 'LEATHER SHOE',   
            name: 'Empress Shoe',
            price: 41000,
            color: 'Black',
            image: require('../assets/theempress.avif'),
            description:
              'A luxurious leather shoe designed to provide a regal and stylish finishing touch with exceptional quality and craftsmanship.'
          }
        ]
      }
    },

 computed: {

  product() {

    const id = Number(this.$route.params.id)

    return this.products.find(product => product.id === id)

  }

},

  methods: {

  addToCart() {

    let cart =
      JSON.parse(localStorage.getItem('cart')) || []

    const existingProduct = cart.find(
      item => item.id === this.product.id
    )

    if (existingProduct) {

      existingProduct.quantity += 1

    } else {

      cart.push({
        ...this.product,
        quantity: 1
      })

    }

    localStorage.setItem(
      'cart',
      JSON.stringify(cart)
    )

    alert('Added to cart!')

  },


  goBack() {

    if (this.product.category === 'LEATHER BAG') {
      this.$router.push('/bags')
    }

    else if (this.product.category === 'LEATHER BELT') {
      this.$router.push('/belts')
    }

    else if (this.product.category === 'LEATHER SHOE') {
      this.$router.push('/shoes')
    }

  }

}
}
</script>

<style scoped>

.product-details-page {
  min-height: 80vh;
  padding: 70px 8%;
  background: #f7f1eb;
}

/* Main product layout */
.details-container {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 70px;
  background: #ffffff;
  padding: 45px;
  border-radius: 8px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
}

/* Product image */
.details-image {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.details-image img {
  width: 100%;
  max-width: 480px;
  height: 500px;
  object-fit: cover;
  border-radius: 6px;
}

/* Product information */
.details-info {
  flex: 1;
}

.product-category {
  color: #b65f4a;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 2px;
  margin-bottom: 12px;
}

.details-info h1 {
  color: #292929;
  font-size: 38px;
  margin-bottom: 12px;
}

.details-info h2 {
  color: #b65f4a;
  font-size: 27px;
  margin-bottom: 22px;
}

.product-line {
  width: 60px;
  height: 3px;
  background: #b65f4a;
  margin-bottom: 25px;
}

/* Description */
.description {
  color: #555;
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 25px;
}

/* Product information */
.product-information {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  padding: 18px 0;
  margin-bottom: 25px;
}

.product-information p {
  margin-bottom: 9px;
  color: #555;
}

.product-information strong {
  color: #292929;
}

/* Features */
.product-features h3 {
  color: #292929;
  font-size: 19px;
  margin-bottom: 12px;
}

.product-features ul {
  padding-left: 20px;
  color: #555;
  line-height: 1.8;
}

/* Buttons */
.details-buttons {
  display: flex;
  gap: 15px;
  margin-top: 30px;
}

.details-buttons button {
  border: none;
  padding: 13px 24px;
  background: #b65f4a;
  color: white;
  font-size: 15px;
  cursor: pointer;
  border-radius: 4px;
  transition: 0.3s ease;
}

.details-buttons button:hover {
  background: #292929;
}

.details-buttons .back-button {
  background: #292929;
}

.details-buttons .back-button:hover {
  background: #b65f4a;
}

/* Product not found */
.product-not-found {
  text-align: center;
  padding: 100px 20px;
}

.product-not-found h2 {
  color: #292929;
  margin-bottom: 15px;
}

.product-not-found p {
  color: #666;
  margin-bottom: 25px;
}

.product-not-found button {
  border: none;
  padding: 12px 25px;
  background: #b65f4a;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

/* Mobile */
@media (max-width: 768px) {

  .product-details-page {
    padding: 40px 20px;
  }

  .details-container {
    flex-direction: column;
    padding: 25px;
    gap: 35px;
  }

  .details-image img {
    height: 350px;
  }

  .details-info h1 {
    font-size: 30px;
  }

  .details-buttons {
    flex-direction: column;
  }

  .details-buttons button {
    width: 100%;
  }
}

</style>
